import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/system',
    meta: { title: '系统管理' },
    component: Layout,
    children: [
      {
        path: 'menu',
        meta: { title: '菜单管理' },
        component: () => import('@/views/system/MenuManage')
      },
      {
        path: 'menu/add',
        meta: {
          title: '新增菜单',
          activeMenu: '/system/menu'
        },
        component: () => import('@/views/system/MenuAdd')
      },
      {
        path: 'menu/edit',
        meta: {
          title: '编辑菜单',
          activeMenu: '/system/menu'
        },
        component: () => import('@/views/system/MenuAdd')
      },
      {
        path: 'organize',
        meta: { title: '组织管理' },
        component: () => import('@/views/system/OrganizeManage')
      },
      {
        path: 'role',
        meta: { title: '角色管理' },
        component: () => import('@/views/system/RoleManage')
      },
      {
        path: 'role/(add|edit)',
        meta: { title: '角色新增' },
        component: () => import('@/views/system/RoleAdd')
      },
      {
        path: 'dict',
        meta: { title: '字典管理' },
        component: () => import('@/views/system/DictManage')
      },
      {
        path: 'account',
        meta: { title: '账号管理' },
        component: () => import('@/views/system/AccountManage')
      },
      {
        path: 'account/add',
        meta: {
          title: '新增账号',
          activeMenu: '/system/account'
        },
        component: () => import('@/views/system/AccountAdd')
      },
      {
        path: 'account/edit',
        meta: {
          title: '编辑账号',
          activeMenu: '/system/account'
        },
        component: () => import('@/views/system/AccountAdd')
      },
      {
        path: 'timeconfig',
        meta: {
          title: '时间配置'
        },
        component: () => import('@/views/timeconfig/TimeConfig')
      },
      {
        path: 'ygUser',
        meta: {
          title: '客户管理',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/YgUserList')
      },
      {
        path: 'ygUser/add',
        meta: {
          title: '新增油罐客户',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/YgUserAdd')
      },
      {
        path: 'ygUser/edit',
        meta: {
          title: '编辑油罐客户',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/YgUserAdd')
      },
      {
        path: 'ygUser/detail',
        meta: {
          title: '详情',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/YgUserDetail')
      },
      {
        path: 'cpyUser',
        meta: {
          title: '成品油客户',
          activeMenu: '/system/cpyUser'
        },
        component: () => import('@/views/system/CpyUserList')
      },
      {
        path: 'cpyUser/add',
        meta: {
          title: '新增成品油客户',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/CpyUserAdd')
      },
      {
        path: 'cpyUser/edit',
        meta: {
          title: '编辑成品油客户',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/CpyUserAdd')
      },
      {
        path: 'khUser/add',
        meta: {
          title: '新增客户',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/KhUserAdd')
      },
      {
        path: 'khUser/edit',
        meta: {
          title: '编辑客户',
          activeMenu: '/system/ygUser'
        },
        component: () => import('@/views/system/KhUserAdd')
      },
      {
        path: 'organizeManage',
        meta: {
          title: '部门管理',
          activeMenu: '/system/organizeManage'
        },
        component: () => import('@/views/system/OrganizeManage')
      },
      {
        path: 'invoiceTitle',
        meta: {
          title: '发票抬头管理',
          activeMenu: '/system/invoiceTitle'
        },
        component: () => import('@/views/system/InvoiceTitle')
      },
      {
        path: 'invoiceTitle/add',
        meta: {
          title: '新增发票抬头',
          activeMenu: '/system/invoiceTitle'
        },
        component: () => import('@/views/system/InvoiceTitleAdd')
      },
      {
        path: 'invoiceTitle/edit',
        meta: {
          title: '编辑发票抬头',
          activeMenu: '/system/invoiceTitle'
        },
        component: () => import('@/views/system/InvoiceTitleAdd')
      },
      {
        path: 'invoiceTitle/detail',
        meta: {
          title: '详情',
          activeMenu: '/system/invoiceTitle'
        },
        component: () => import('@/views/system/InvoiceTitleDetail')
      },
      {
        path: 'newInvoice',
        meta: {
          title: '发票管理',
          activeMenu: '/system/newInvoice'
        },
        component: () => import('@/views/invoiceManage/InvoiceManage')
      },
      {
        path: 'newInvoice/add',
        meta: {
          title: '新增发票',
          activeMenu: '/system/newInvoice'
        },
        component: () => import('@/views/invoiceManage/InvoiceManageAdd')
      },
      {
        path: 'newInvoice/edit',
        meta: {
          title: '编辑发票',
          activeMenu: '/system/newInvoice'
        },
        component: () => import('@/views/invoiceManage/InvoiceManageAdd')
      },
      {
        path: 'newInvoice/detail',
        meta: {
          title: '发票详情',
          activeMenu: '/system/newInvoice'
        },
        component: () => import('@/views/invoiceManage/InvoiceManageDetail2')
      }
    ]
  }
]
